import { Button, Checkbox } from '@acpaas-ui/react-components';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import AdminAddContactPartnerFields from '../../components/admin/contacts/AdminContactPartnerFields';
import AdminContactSchoolFields from '../../components/admin/contacts/AdminContactSchoolFields';
import { ADMIN_CONTACT_PARTNER, ADMIN_CONTACT_SCHOOL } from '../../constants/admin.contacts.constants';
import { getCanSubmitParterOrganization, getCanSubmitSchoolOrganization } from '../../lib/contact.utils';
import { currentUserSelector } from '../../selectors/auth.selectors';
import Modal from '../Modal';
import ModalTitle from '../ModalTitle';

const ContactOrganizationModal = ({
  isOpen,
  isEdit,
  onInput,
  type,
  data,
  organizationsDependency,
  netsDependency,
  managementsDependency,
  communitiesDependency,
  schoolsDependency,
  branchesDependency,
  onConfirm,
  onDelete,
  onClose
}) => {
  const currentUser = useSelector(currentUserSelector);
  const modalContentRef = useRef(null);

  const renderApprovedInput = () => {
    const disabled = type === ADMIN_CONTACT_SCHOOL && currentUser?.type === ADMIN_CONTACT_PARTNER;

    return (
      <div className="u-margin-top-md u-margin-bottom-xx">
        <Checkbox
          disabled={disabled}
          label={`Goedgekeurd`}
          checked={data?.isApproved ?? false}
          onChange={() => onInput(!data?.isApproved, 'isApproved')}
        />
      </div>
    );
  };

  return (
    <Modal
      ref={modalContentRef}
      className="spo-o-add-contact-organization-modal"
      title={<ModalTitle title={`Organisatie ${isEdit ? 'aanpassen' : 'toevoegen'}`} />}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      canConfirm={
        type === ADMIN_CONTACT_PARTNER ? getCanSubmitParterOrganization(data) : getCanSubmitSchoolOrganization(data)
      }
      onConfirmLabel={isEdit ? 'Aanpassen' : 'Toevoegen'}
      onConfirmIcon="ai-check-1"
      extraFooterActions={
        isEdit && (
          <Button type="danger" outline onClick={onDelete}>
            Verwijderen
          </Button>
        )
      }
    >
      <AdminContactSchoolFields
        type={type}
        onInput={onInput}
        data={data}
        netsDependency={netsDependency}
        managementsDependency={managementsDependency}
        communitiesDependency={communitiesDependency}
        schoolsDependency={schoolsDependency}
        branchesDependency={branchesDependency}
        parentElement={modalContentRef.current}
      />
      <AdminAddContactPartnerFields
        type={type}
        organizationsDependency={organizationsDependency}
        onInput={onInput}
        data={data}
        parentElement={modalContentRef.current}
      />
      {renderApprovedInput()}
    </Modal>
  );
};

export default ContactOrganizationModal;
